export const phoneNumber = "+91 91504 55866";
export const phoneNumber2 = "+91 91507 20866";

export const whatsappUrl =
  "https://wa.me/919150455866?text=Hi%20The%20Burma%20Idiyappam,%20I%20have%20an%20enquiry.";
export const whatsappSubscriptionUrl =
  "https://wa.me/919150455866?text=Hi%20The%20Burma%20Idiyappam,%20I'd%20like%20a%20quote%20for%20the%20employee%20snack%20subscription%20for%20my%20office.";

export const instagramUrl = "https://instagram.com/burmaidiyappam";

export const swiggyUrl =
  "https://www.swiggy.com/direct/brand/558542?source=swiggy-direct&subSource=generic";
export const zomatoUrl = "https://link.zomato.com/xqzv/rshare?id=6917608230563d70";

export const swiggyLogoUrl = "/icons/swiggy.svg";
export const zomatoLogoUrl = "/icons/zomato.svg";
export const whatsappLogoUrl = "/icons/whatsapp.svg";
export const bniLogoUrl = "/bni-chanakyaas-logo.png";

export const address =
  "6, Sarvodaya Main Rd, Mahaboopalayam, Madurai, Tamil Nadu 625016";
export const mapUrl =
  "https://www.google.com/maps?q=9.9212736,78.1040554&z=17&output=embed";

// Google Apps Script web app URL tied to the enquiries Google Sheet.
// See README.md → "Enquiry Form & Google Sheets" to set up or rotate this.
export const enquiryFormEndpoint =
  "https://script.google.com/macros/s/AKfycbz9aM0PTacs92_k4v5O-UR5vR13HzKiQmc-MQURomFzD5jHezKoFKpir98cELvI_ceCcw/exec";
